import React, { useState, useEffect } from "react";
import {
  Box,
  Paper,
  CircularProgress,
  Stack,
  Typography,
  Button,
  useMediaQuery,
} from "@mui/material";
import { useWarehouse } from "../../../contexts/WarehouseContext";
import axios from "../../../network";
import LottieError from "../../../components/LottieError";
import ProfileHeader from "./ProfileHeader";
import StoreDetails from "./StoreDetails";
import PickupDetails from "./PickupDetails";
import _ from "lodash"; 
import { AntSwitch } from "../../../components/AntSwitch";


const Profile = () => {
  const [profileData, setProfileData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false); 
  const [checked, setChecked] = useState(true);
  const [error, setError] = useState(false);
  const { warehouseId } = useWarehouse();

  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const fetchProfileData = async () => {
    try {
      const response = await axios.get(
        `/warehouses/profileDetails/${warehouseId}`
      );
      const data = response.data.data;
     
      if (data) {
        setProfileData(data);
        setChecked(data?.ondcSellerInfo?.isActive);
        setLoading(false);
        setError(false);
      } else {
        setLoading(false);
        setError(true);
      }
    } catch (err) {
      console.error("Error fetching data:", err);
      setLoading(false);
      setError(true);
    }
  };

  const updateProfile = async (updatedData) => {
    setSaving(true); // Start saving
    try {
      const requestData = { ...profileData, ...updatedData };
      const response = await axios.post(
        `/warehouses/updateBikriStore/${warehouseId}`,
        requestData
      );
      if (response.data.result) {
        alert("Profile updated successfully!");
      } else {
        alert("Profile could not be updated. Please try again!");
      }
    } catch (err) {
      console.error("Error updating profile:", err);
      alert("Failed to update profile.");
    } finally {
      setSaving(false); 
    }
  };

  useEffect(() => {
    fetchProfileData();
  }, [warehouseId]);

 
  const debouncedUpdateProfile = React.useCallback(
    _.debounce((updatedData) => {
      updateProfile(updatedData);
    }, 500), 
    [profileData]
  );

  const handleChange = (event) => {
    const newChecked = event.target.checked;
    setChecked(newChecked);
  
    setProfileData((prevState) => {
      const updatedData = {
        ...prevState,
        ondcSellerInfo: {
          ...prevState.ondcSellerInfo,
          isActive: newChecked,
        },
      };
      debouncedUpdateProfile(updatedData);
      return updatedData;
    });
  };

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100%"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error || profileData.length === 0) {
    return (
        <LottieError />
    );
  }

  return (
    <Box sx={{ background: "#f0f0f0", height: "120%", overflowY: "auto" }}>
      <Paper sx={{ boxShadow: 7, p: 3 }}>
        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          justifyContent="flex-end"
          sx={{ mb: 2 }}
        >
          <Typography variant="h4">{checked ? "Open" : "Closed"}</Typography>
          <AntSwitch checked={checked} onChange={handleChange} size="small" />
        </Stack>
        <ProfileHeader storeName={profileData?.ondcSellerInfo?.storeName} imageUrl={profileData?.customData?.image} />
        <StoreDetails
          profileData={profileData}
          setProfileData={setProfileData}
        />
        <PickupDetails
          profileData={profileData}
          setProfileData={setProfileData}
        />
      </Paper>
      <Box
          sx={{
            position: "fixed",
            bottom: isSmallScreen ? 55 : 0,
            backgroundColor: "#fff",
            textAlign: "center",
            zIndex: 2, 
            width: '100%',
            marginBottom: 1,
            display: 'flex',
            justifyContent: 'center'
           
          }}
        >
          <Button
            variant="contained"
            onClick={() => updateProfile(profileData)}
            disabled={saving} 
          >
            {saving ? "Saving..." : "Save Changes"}
          </Button>
        </Box>
    </Box>
  );
};

export default Profile;
